import * as api from '../connectivity/api.auth';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { push } from 'react-router-redux';
import * as types from '../constants/actionTypes';


export function* doRefreshToken(action){

  try{
    const responseBody = yield call(api.refreshToken, action.payload.user_id, action.payload.access_token);
    yield put({type: types.OAUTH__TOKEN__REFRESH__SUCCEEDED, payload: {
      id: responseBody.user_id,
      username: responseBody.username,
      token: responseBody.access_token,
      expires: responseBody.expires
    }});
  } catch (e) {
    yield put({type: types.OAUTH__TOKEN__REFRESH__FAILED, message: e.message});
  }

}

export function* watchRefreshToken() {
  yield takeLatest(types.OAUTH__TOKEN__REFRESH__REQUESTED, doRefreshToken);
}

export function* doTokenExpired(){
  yield put({type: types.UNAUTHENTICATE, payload: {}});
}

export function* watchTokenExpired() {
  yield takeLatest(types.OAUTH__TOKEN__EXPIRED, doTokenExpired);
}

export function* doLogoutRequested() {
  yield put({
    type: types.LOGOUT__COMPLETED
  });

  // redirect to /logout
  yield put(
    push('/logout')
  );
}

export function* watchLogoutRequested() {
  yield takeLatest(types.LOGOUT__REQUESTED, doLogoutRequested);
}



/** WEBPACK FOOTER **
 ** ./src/sagas/auth.saga.js
 **/